require("jquery-ui/ui/widgets/autocomplete.js");
function PropertyAutoComplete() {    
    $(function () {
        $("#propertySearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "propertySearch",
                    type: "POST",
                    dataType: "json",
                    data: { propertySearch: request.term },
                    success: function (data) {
                        $("#RelatedProperty").val('0');
                        response($.map(data, function (item) {                            
                            return { label: item.name , value: item.propertyId };
                        }))
                    }
                })
            },
            select: function (event, ui) {  
                $("#RelatedProperty").val(ui.item.value);
                $("#propertySearch").val(ui.item.label);

                PopulateLocationDropdown(ui.item.value);
                return false;
            }
        });

        $("#assetSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "assetSearch",
                    type: "POST",
                    dataType: "json",
                    data: {
                        assetSearch: request.term, propertyId: $('#RelatedProperty').val(), locationId: $("#LocationId").val()
                    },
                    success: function (data) {
                        $("#AssociatedAsset").val('0');
                        response($.map(data, function (item) {
                            return { label: item.assetName, value: item.recordId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#AssociatedAsset").val(ui.item.value);
                $("#assetSearch").val(ui.item.label);
                return false;
            }
        });

        $("#reportedBySearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "contactSearch",
                    type: "POST",
                    dataType: "json",
                    data: { contactSearch: request.term },
                    success: function (data) {
                        $("#ReportedByID").val('0');
                        response($.map(data, function (item) {
                            return { label: item.name, value: item.contactId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#ReportedByID").val(ui.item.value);
                $("#reportedBySearch").val(ui.item.label);
                return false;
            }
        });
        $("#affectedPersonSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "contactSearch",
                    type: "POST",
                    dataType: "json",
                    data: { contactSearch: request.term },
                    success: function (data) {
                        $("#AffectedPersonID").val('0');
                        response($.map(data, function (item) {
                            return { label: item.name, value: item.contactId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#AffectedPersonID").val(ui.item.value);
                $("#affectedPersonSearch").val(ui.item.label);
                return false;
            }
        });
    });

    function PopulateLocationDropdown(propId, locId) {

        $.ajax({
            type: "GET",
            url: "LocationFilter",
            data: { propertyId: propId },
            success: function (data) {
                var s = '<option value="0">Please Select a Location</option>';
                for (var i = 0; i < data.length; i++) {
                    s += '<option value="' + data[i].id + '">' + data[i].path + '</option>';
                }
                $("#locationsDropdown").html(s);
                if (locId != 0 && locId != "") {
                    $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
                }
            }
        });

    }
}

module.exports = PropertyAutoComplete;
